import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component,  input, signal, WritableSignal } from '@angular/core';
import { FormatSSNPipe } from '@k12/pipes';

@Component({
  imports: [
    CommonModule,
    FormatSSNPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
   
  selector: 'lib-masked-box',
  templateUrl: './masked-box.component.html',
  styleUrl: './masked-box.component.scss'
})
export class MaskedBoxComponent {
  
  public disabled = input<boolean>(false); 
  public label = input.required<string>();
  public name = input.required<string>();  
  public isMasked: WritableSignal<boolean> = signal(true);
  public maskedString = input.required<string>();
  public maskedValue = input.required<string>();
  public trueValue = input.required<string>();
  public tabIndex = input.required<number>();


  
}